import { watch, computed } from 'vue'
import { isString } from '@/utils/is'
import { useAppStoreWithOut } from '@/store/modules/app'
import { useUserStoreWithOut } from '@/store/modules/user'
import { useI18n } from '@/hooks/web/useI18n'

export const useTitle = (newTitle?: string) => {
  const { t } = useI18n()
  const appStore = useAppStoreWithOut()
  const userStore = useUserStoreWithOut()

  // 使用 computed 动态计算标题，确保响应式更新
  const title = computed(() => {
    const baseTitle = appStore.getTitle
    return newTitle ? `${baseTitle} - ${t(newTitle as string)}` : baseTitle
  })

  // 监听标题变化，更新 document.title
  watch(
    title,
    (n, o) => {
      if (isString(n) && n !== o && document) {
        document.title = n
      }
    },
    { immediate: true }
  )

  // 监听 userStore.getConfig?.system_name 的变化，确保标题及时更新
  watch(
    () => userStore.getConfig?.system_name,
    () => {
      if (document && isString(title.value)) {
        document.title = title.value
      }
    },
    { deep: true }
  )

  return title
}
